import { useEffect, useState } from 'react';

import './Empresas.css'

// Bibliotecas de terceiros
import { Box, Divider, Paper, TextField, ThemeProvider, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'

// Componentes personalizados
import Loading from '../../components/loading/Loading';

// DTOs
import { Empresa } from '../../dto/Empresa';
import { UserInfo } from '../../dto/UserInfo';

// Serviços
import { EmpresaServices } from '../../services/EmpresaService';

// Helpers
import { mostraMensagemErro, mostraMensagemSucesso } from '../../helpers/Notificacoes';
import BarraMenu from '../../components/barraMenu/BarraMenu';
import { ModoBarra } from '../../components/utils';
import { temaEdicao, temaVisualizacao } from '../../components/theme/Theme';
import { BusinessRounded } from '@mui/icons-material';


interface CadEmpresaProps {
    modoInicial?: ModoBarra;
    empresaSelecionada?: any;
}

const CadEmpresa: React.FC<CadEmpresaProps> = ({ modoInicial, empresaSelecionada }) => {

    // Navegação / rota
    const navigate = useNavigate();
    //const location = useLocation();

    // Services
    const empresaService = new EmpresaServices();

    // User info
    const [userInfo] = useState<UserInfo>(JSON.parse(localStorage.getItem('udbs')!));

    // Constantes fixas
    const DADOS_VAZIOS: Empresa = {
        idEmpresa: null,
        codEmpresa: null,
        descricao: '',
        apiKey: '',
        usuariosAtivos: '',
    };

    // Estados principais da empresa
    const [empresaOriginal, setEmpresaOriginal] = useState<Empresa | null>(null);
    const [empresa, setEmpresa] = useState<Empresa>(empresaSelecionada ?? DADOS_VAZIOS);

    // Estado de edição
    const [modoEdicao, setModoEdicao] = useState<ModoBarra>(modoInicial ?? ModoBarra.leitura);
    const isEditavel = modoEdicao === ModoBarra.edicaoregistro || modoEdicao === ModoBarra.novoregistro;
    const [tema, setTema] = useState(temaVisualizacao);
    const [dadosEditados, setDadosEditados] = useState(false);

    // Estado de interface
    const [isLoading, setIsLoading] = useState(false);

    // Datas
    const [dataLancamento] = useState(() => {
        const dataAtual = new Date();
        return dataAtual.toLocaleString("pt-BR");
    });

    function verificaAlteracoes() {
        if (empresa !== empresaOriginal) {
            setDadosEditados(true);
        }

        return false;
    }


    //busca os dados da empresa selecionada
    useEffect(() => {
        const buscaDados = async () => {
            if (modoInicial === 'novoregistro') {
                return;
            }
            setIsLoading(true)

            setIsLoading(false);
        };
        buscaDados();
    }, [modoInicial]);


    function updatePage(page: string, espera?: boolean) {

        if (espera) {
            setTimeout(() => {
                navigate("/mvp", {
                    state: {
                        propsPage: page
                    }
                });
            }, 3000);
        } else {
            navigate("/mvp", {
                state: {
                    propsPage: page
                }
            });
        }
    };


    const salvarEmpresa = async () => {
        setIsLoading(true);

        try {
            const cadastroEmpresa: Empresa = {
                idEmpresa: empresa?.idEmpresa!,
                codEmpresa: null,
                descricao: empresa.descricao,
                apiKey: empresa.apiKey,
                usuariosAtivos: empresa.usuariosAtivos
            };

            const empresaSaved = await empresaService.put(`/v1/empresa`, undefined, [cadastroEmpresa]);
            if (empresaSaved.codigo === 200) {
                mostraMensagemSucesso("Empresa cadastrada com sucesso");

                // Atualiza estado com a empresa salva
                setEmpresa(cadastroEmpresa);
                setEmpresaOriginal(cadastroEmpresa);

                if (modoInicial === ModoBarra.edicao) {
                    setModoEdicao(ModoBarra.edicao); // mostra botão "Editar"
                } else {
                    setModoEdicao(ModoBarra.insercao); // mostra botão "Novo"
                }

            } else {
                mostraMensagemErro(empresaSaved.mensagem);
            }
            setIsLoading(false);

        } catch (error: any) {
            console.error('Erro ao salvar empresa:', error);
            mostraMensagemErro('Erro ao salvar empresa:' + error.erro);
            return;

        } finally {
            setIsLoading(false);
        }
    };

    function voltar() {
        if (dadosEditados) {
            const confirma = window.confirm('Os dados preenchidos serão perdidos');

            if (confirma) {
                updatePage('empresas');
            }
            else return;
        }
        updatePage('empresas');
    };

    function EditarEmpresa() {
        setEmpresaOriginal(empresa); // guarda o estado original
        setModoEdicao(ModoBarra.edicaoregistro);
        setTema(temaEdicao);
    }

    function NovaEmpresa() {
        setEmpresaOriginal(null); // limpa estado original
        setEmpresa(DADOS_VAZIOS);
        setModoEdicao(ModoBarra.novoregistro);
        setTema(temaEdicao);
    }

    function Cancelar() {
        if ((modoEdicao === ModoBarra.edicaoregistro || modoEdicao === ModoBarra.novoregistro) && empresaOriginal) {
            setEmpresaOriginal(empresaOriginal!);
            setModoEdicao(ModoBarra.edicao);
            setTema(temaVisualizacao);

        } else {
            setEmpresa(DADOS_VAZIOS);
            setModoEdicao(ModoBarra.leitura);
        }

    }


    return (
        <div className="paginaCadastro">
            <ThemeProvider theme={tema}>
                <Box className='containerFormCadastro'>
                    <Paper elevation={0} className='empresa-paper-header'>
                        <Box className='empresa-cad-header-row'>
                            <Box className='empresa-cad-title-wrap'>
                                <Box className='empresa-cad-title-icon'>
                                    <BusinessRounded sx={{ color: '#0965c1', fontSize: 28 }} />
                                </Box>
                                <Box>
                                    <Typography className='empresa-cad-title'>
                                        Cadastro de Empresa
                                    </Typography>
                                    <Typography className='empresa-cad-subtitle'>
                                        Gerencie as informações e dados da empresa cadastrada.
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className='empresa-cad-actions'>
                                <BarraMenu
                                    modoAtual={modoEdicao}
                                    onAcao={(acao) => {
                                        if (acao === "edicaoregistro") EditarEmpresa();
                                        if (acao === "cancelar" || acao === "voltar") Cancelar();
                                        if (acao === "novoregistro") NovaEmpresa();
                                        if (acao === "sair") voltar();
                                        if (acao === "salvar") salvarEmpresa();
                                    }}
                                />
                            </Box>
                        </Box>
                    </Paper>
                    <Box className='empresa-form-card'>
                        {isLoading && <Loading />}
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                             <Box>
                                <Typography className='empresa-cad-title'>
                                    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                                        <BusinessRounded sx={{ color: '#0965c1', fontSize: 18 }} />
                                        Dados da Empresa
                                    </Box>
                                </Typography>
                                <Divider className='empresa-divider' />
                            </Box>
                            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                                <TextField label="Código"
                                    sx={{ width: 120 }}
                                    size="small"
                                    value={empresa.codEmpresa || ''}
                                    InputLabelProps={{ shrink: true }}
                                    disabled={true} />

                                <TextField
                                    label="Api key"
                                    value={empresa.apiKey || ''}
                                    sx={{ width: 250 }}
                                    size="small"
                                    onChange={(e) => setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        apiKey: e.target.value
                                    }))}
                                    required
                                    disabled={modoEdicao === ModoBarra.novoregistro ? false : true}
                                />

                                <TextField
                                    label="Razão Social"
                                    value={empresa?.descricao || ''}
                                    variant="outlined"
                                    sx={{ width: 440 }}
                                    size="small"
                                    onChange={(e) => setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        descricao: e.target.value
                                    }))}
                                    required
                                    disabled={!isEditavel}
                                    inputProps={{ maxLength: 60 }}
                                />

                                <TextField
                                    label="Usuários ativos"
                                    value={empresa?.usuariosAtivos || ''}
                                    onChange={(e) => setEmpresa((prevEmpresa) => ({
                                        ...prevEmpresa,
                                        usuariosAtivos: e.target.value,
                                    }))}
                                    required
                                    sx={{ width: 155 }}
                                    size="small"
                                    disabled={!isEditavel}
                                />
                            </Box>
                        </Box>
                        <ToastContainer />
                    </Box>
                </Box>
            </ThemeProvider>
        </div>
    );
}

export default CadEmpresa;
